"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestAnimationFrame = getRequestAnimationFrame;
exports.getCancelAnimationFrame = getCancelAnimationFrame;
exports.throttle = throttle;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var prefixes = ['ms', 'moz', 'webkit', 'o'];
var lastTime = 0;

function getRequestAnimationFrame() {
  var raf = window.requestAnimationFrame;
  prefixes.forEach(function (prefix) {
    if (window.requestAnimationFrame && window.cancelAnimationFrame) return;
    raf = raf || window[prefix + 'RequestAnimationFrame'];
  });
  if (!raf) raf = function raf(callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(callback, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
  return raf;
}

function getCancelAnimationFrame() {
  var cancelRaf = window.cancelAnimationFrame;
  prefixes.forEach(function (prefix) {
    if (window.requestAnimationFrame && window.cancelAnimationFrame) return;
    cancelRaf = cancelRaf || window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame'];
  });
  if (!cancelRaf) cancelRaf = function cancelRaf(id) {
    clearTimeout(id);
  };
  return cancelRaf;
}

function throttle(callback) {
  var raf = getRequestAnimationFrame();
  var pending = false;
  var lastArgs;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;
    if (pending) return;
    pending = true;
    raf(function () {
      callback.apply(void 0, (0, _toConsumableArray2.default)(lastArgs));
      pending = false;
    });
  };
}